import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { append, concat, path, paths, props } from 'ramda'
import classNames from 'classnames'
import { getDeviceShareLink, getWidgetTitle, getDeviceLabel, widgetWhat, widgetPinned, widgetExpanded, WIDGET_CONFIG, getDeviceSetting } from '../../common/ambient'
import { ambient } from '@aw_products/ambient-weather-common'

import {
  EditableWidgetTitleInput,
  ToggleDevicePublicBtn
} from './'
import {
  MinMaxBtns,
  Share,
  UtilityMenu
} from '../../components/'
import { bindOnlyUserActions } from '../user/redux/bindUserActions'

class Widget extends PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onPin: PropTypes.func,
    device: PropTypes.object,
    notExpandable: PropTypes.bool,
    hidden: PropTypes.bool,
    actions: PropTypes.object, // userActions
    className: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ])
  }

  constructor(props) {
    super(props)
    this._tout = false
    this.state = {}
    this.rand = ::this.rand
  }
  componentDidMount() {
    window.addEventListener('resize', this.rand)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.rand)
  }
  rand() {
    this.setState({
      rand: Math.random()
    })
  }
  render() {
    const { user, actions, onPin, hidden, type, onChange, device, notExpandable, className, extraButtons } = this.props
    const expanded = widgetExpanded(type, device)
    const pinned = widgetWhat('pinned', type, device)
    const minimized = widgetWhat('minimized', type, device)
    const expandable = []
    let onExpand
    if (!notExpandable) {
      onExpand = () => {
        if (onChange) {
          onChange({ expanded: !expanded }, type)
        }
      }
    }
    const id = type === 'solar' ? 'solarradiation' : type
    let onPinFn
    if (onPin) {
      onPinFn = () => {
        if (onChange) {
          onChange({ pinned: !pinned }, type)
        }
      }
    }
    const widgetStyle = {}
    const commonSharePaths = [
      ['currentDevice', 'settings', type],
      ['currentDevice', 'unitSetting', 'image'],
      ['currentDevice', 'lastData', 'dateutc'],
      ['currentDevice', 'tz'],
      ['currentDevice', 'info', 'name'],
      ['currentDevice', 'info', 'coords', 'location'],
      ['user', 'info', 'image'],
    ]
    let share, shareProps
    if(WIDGET_CONFIG[type].share) {
      if (WIDGET_CONFIG[type].share.paths) {
        shareProps = {
          title: getDeviceLabel(device),
          description: `${getWidgetTitle(device, type)}`,
          redirect: getDeviceShareLink(device),
          paths: concat(commonSharePaths, WIDGET_CONFIG[type].share.paths),
          component: WIDGET_CONFIG[type].share.component,
          currentDevice: device,
          childComponent: this.childComponent // Pass the child component reference
        }

        share = <Share {...shareProps} /> 
      }
      const userId = path(['info', '_id'], user)
      if (WIDGET_CONFIG[type].share.social && userId && userId === device.userId) {
        share = <a className='share' onClick={() => {
          const cp = () => {
            console.log('shareProps', shareProps)         
            actions.doModal({ 
              type: 'create-post', 
              data: {
                currentDevice: device,
                postType: `widget-${type}`,
                share: shareProps
              },
            })
          }
          if (!device.public && !path(['info', 'slug'], device)) {
            actions.doModal({
              type: 'toggle-public-device',
              data: {
                currentDevice: device,
                onClick: cp 
              }
            })
          } else {
            cp()
          }
        }} />
      }
    } else if (type === 'webcam') {
      share = <a className='share' onClick={() => {
        actions.doModal({ 
          type: 'create-post', 
          data: {
            currentDevice: device,
            webcamSnapshot: device._id
          }
        })
      }} />
    }
    return (
      <div
        className={classNames(
          'device-widget',
          'square',
          type,
          className,
          {
            hidden,
            expanded,
            minimized,
            pinned,
            kestrel: ambient.deviceIsAKestrel(device)
          }
        )}
        style={widgetStyle}
        ref={(el) => {
          this.widgetEl = el
        }}
      >
        <header>
          <EditableWidgetTitleInput
            type={type}
            currentDevice={device}
            onChange={onChange}
          />
          <UtilityMenu>
            <a
              className='minimize-link'
              onClick={(e) => {
                if (onChange) {
                  onChange({ minimized: true }, type)
                }
              }}
            >
              Minimize Tile
            </a>
            {share}
            <a
              className='graph-link'
              onClick={(e) => {
                if (onChange) {
                  onChange({ dashboard: { minimized: true } }, type)
                }
              }}
            >
              Go to Graph 
            </a>
            <a
              className='up-link'
              onClick={(e) => {
                if (onChange) {
                  onChange({ reorder: -1 }, type)
                }
              }}
            >
              Move <span className='desktop'>Left</span><span className='phone'>Up</span>
            </a>
            <a
              className='down-link'
              onClick={(e) => {
                if (onChange) {
                  onChange({ reorder: 1 }, type)
                }
              }}
            >
              Move <span className='desktop'>Right</span><span className='phone'>Down</span>
            </a>
          </UtilityMenu>
        </header>
        {React.cloneElement(this.props.children, {
          ref: (ref) => { this.childComponent = ref; }
        })}
        <MinMaxBtns
          expanded={expanded}
          pinned={pinned}
          id={id}
          onExpand={onExpand}
          onGraph={() => {
            if (onChange) {
              onChange({ dashboard: { minimized: true } }, type)
            }
          }}
          onMinus={() => {
            if (onChange) {
              onChange({ minimized: true }, type)
            }
          }}
          onPin={onPinFn}
          onUp={() => {
            if (onChange) {
              onChange({ reorder: -1 }, type)
            }
          }}
          onDown={() => {
            if (onChange) {
              onChange({ reorder: 1 }, type)
            }
          }}
        >
          {extraButtons}
        </MinMaxBtns>
      </div>
    )
  }
}

export default bindOnlyUserActions(Widget)

Widget.displayName = 'Widget'
